import { offersWidget } from '../offers/main'
import style from '../../scss/pages/subpages/letenky-dle-zajmu.scss'

(function ($) {
  $.fn.extend({
    offersWidget: offersWidget
  })
})(jQuery);



/** WEBPACK FOOTER **
 ** c:/Users/martin.nikl/Desktop/SA GITLAB/frontend/sites/letenky.cz/src/js/subpages/letenky-dle-zajmu.js
 **/